import { render, staticRenderFns } from "./TlwSSO.vue?vue&type=template&id=6777934f&scoped=true"
import script from "./TlwSSO.vue?vue&type=script&lang=js"
export * from "./TlwSSO.vue?vue&type=script&lang=js"
import style0 from "./TlwSSO.vue?vue&type=style&index=0&id=6777934f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6777934f",
  null
  
)

export default component.exports